import { useRuntimeConfig } from '#imports'
import type { RouteRecordRaw } from 'vue-router'

import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

export default (): RouteRecordRaw[] => {
  const { market } = useMarketplace()
  const { FF_ENABLE_US_TELCO_COMPARATORS_COUNTRIES } = useRuntimeConfig().public

  return [
    {
      name: 'partnerships-us-telco-comparators-landing-page',
      path: 'partnerships/us-telco-comparators',
      component: () =>
        import('~/scopes/partnerships/pages/UsTelcoComparatorsLandingPage/UsTelcoComparatorsLandingPage.vue'),
      meta: {
        owners: ['bot-squad-partnerships-front'],
        routeExists: () =>
          FF_ENABLE_US_TELCO_COMPARATORS_COUNTRIES.includes(market.countryCode),
        tracking: { contentGroup: 'Partnerships' },
      },
    },
    {
      name: 'partnerships-bouygues-offers-webview',
      path: 'partnerships/webview',
      meta: {
        layout: false,
        tracking: { contentGroup: 'Partnerships' },
      },
      children: [
        {
          name: 'partnerships-webview-bouygues-offers',
          path: 'bouygues-offers',
          component: () =>
            import('~/scopes/partnerships/pages/BouyguesOffersWebview/BouyguesOffersWebview.vue'),
          meta: {
            owners: ['bot-squad-partnerships-front'],
          },
        },
      ],
    },
  ]
}
